import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const rubricaDataUpdateaSlice = createSlice({
	name: 'rubricaDataUpdateaState',
	initialState,
	reducers: {
		setTrueUpdateaData: (state) => {
			return true;
		},
		setFalseUpdateaData: (state) => {
			return false;
		}
	}
});

export const { setTrueUpdateaData, setFalseUpdateaData } = rubricaDataUpdateaSlice.actions;

export default rubricaDataUpdateaSlice.reducer;
